<template>
  <portal to="modals">
    <transition name="slide-up">
      <div v-if="visible" class="overlay" @click.self="handleClose">
        <div class="panel">
          <slot />
        </div>
      </div>
    </transition>
  </portal>
</template>

<script>
export default {
  name: 'BottomSlidePanel',
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    handleClose () {
      this.$emit('close')
    }
  },
  watch: {
    visible (val) {
      if (val) {
        console.log('Panel opened')
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    }
  }
}
</script>

<style scoped>
  .overlay {
    position: fixed;
    inset: 0;
    background: transparent;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    z-index: 1000;
  }

  .panel {
    width: 100%;
    height: 70vh;
    background: #fff;
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.2);
    overflow-y: auto;

    /* 隱藏 scrollbar */
    -ms-overflow-style: none; /* IE10+ */
    scrollbar-width: none; /* Firefox */
  }

  .panel::-webkit-scrollbar {
    display: none; /* Chrome/Safari 隱藏 */
  }

  /* 動畫 */
  .slide-up-enter-active,
  .slide-up-leave-active {
    transition: transform 0.3s ease;
  }
  .slide-up-enter,
  .slide-up-leave-to {
    transform: translateY(100%);
  }
</style>
